// extracted by mini-css-extract-plugin
module.exports = {"tabs":"LandingPage_tabs__dcwb5"};